import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IEOtpremnicaDto, IStrankaOtpremniceDto, TipOtpremnice, TipStranke } from '@kodit/core/data-api';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { Subscription } from 'rxjs';
import { EotpremnicaFormService, StrankaOtpremniceForm } from '../../otpremnice/eotpremnica-form.service';
import { RacunService } from '@kodit/core/services';

@Component({
  selector: 'kodit-stranka-eotpremnice',
  templateUrl: './stranka-eotpremnice.component.html',
  styleUrls: ['./stranka-eotpremnice.component.scss']
})
export class StrankaEotpremniceComponent implements OnInit, OnDestroy {

 /** Configs */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.LARGE);

  /** Props */
  private _subs: Subscription = new Subscription();
  nazivNepronadjeneStranke: string;
  fizickoLiceTip = TipStranke.FIZIKO_LICE;
  fizickoLiceNaziv: string;
  isFirstLoad: boolean = true;
  disableStranka: boolean = false;
  jeInterna : TipOtpremnice = TipOtpremnice.INTERNA;

  jeInostranoPravnoLice: boolean;
  form: StrankaOtpremniceForm;

  /** I/O */
  @Input() otpremnicaFormGroup: FormGroupTypeSafe<IEOtpremnicaDto>;

  constructor(
    private _otpremnicaService: EotpremnicaFormService,
    private _racunService: RacunService,
    private _route: ActivatedRoute,
    private _dialogService: DynamicDialogService,
    //private _strankaRacunaFormService: StrankaRacunaFormService
  ) {}

  ngOnInit(): void {
    this.setStranka();
    // this._subs.add(
    //   this._racunService.getShowFizickoLiceCreate.subscribe((res) => {
    //     this.nazivNepronadjeneStranke = res;
    //   })
    // );
    // if (
    //   this._route.snapshot.data.racun?.racunDto?.strankaRacunaDto
    //     ?.tipStranke === TipStranke.FIZIKO_LICE &&
    //   !this._route.snapshot.data.racun?.racunDto?.strankaRacunaDto?.id
    // ) {
    //   this._racunService.setPerformSearchFizickogLica = this.racunFormGroup.value.strankaRacunaDto?.naziv;
    // }

    this._subs.add(
      this._otpremnicaService.tipOptremnice$.subscribe((value) => {
        this.disableStranka = value == this.jeInterna;
      })
    );
  }

  onSelectionChange(stranka: IStrankaOtpremniceDto) {
    this._otpremnicaService.setStrankaOtpremnice = stranka;

    if (stranka.id) {
      this.jeInostranoPravnoLice =
        stranka.registracioniBroj != undefined &&
        stranka.registracioniBroj != null;
    }
  }

  setStranka() {
    this.form = this._otpremnicaService.getStrankaEOtpremniceFormGroup;
    this.jeInostranoPravnoLice =
      this.form.controls.registracioniBroj.value != undefined &&
      this.form.controls.registracioniBroj.value != null;
  }

  onSelectionClear() {
    this.otpremnicaFormGroup.controls.strankaDto.reset();
  }

  handleCreateFizickoLice() {
    this.dialogConfig.header = 'Unos fizičkog lica';

    const nazivFizickoLica = this.otpremnicaFormGroup.value.strankaDto.naziv
      ? this.otpremnicaFormGroup.value.strankaDto.naziv.split(' ')
      : this.fizickoLiceNaziv?.split(' ') ?? [''];
    this.dialogConfig.data = {
      ime: nazivFizickoLica[0],
      prezime: nazivFizickoLica
        .filter((x) => x != nazivFizickoLica[0])
        .join(' '),
      grad: this.otpremnicaFormGroup.value.strankaDto?.adresa,
    };

    this.openDialog(this.dialogConfig);
    //this._racunService.setShowFizickoLiceCreate = null;
  }

  handleNazivChange(naziv: string) {
    this.fizickoLiceNaziv = naziv;
  }

  openDialog(config: DynamicDialogConfig) {
    // const ref = this._dialogService.open(FizickoLiceFormComponent, config);

    // this._subs.add(
    //   ref.onClose.subscribe((result: ResultOfFizickoLiceVm) => {
    //     if (result) {
    //       this.racunFormGroup.controls.strankaRacunaDto.patchValue({
    //         id: result.data.fizickoLiceDto.id,
    //         naziv: result.data.fizickoLiceDto.naziv,
    //         adresa: result.data.fizickoLiceDto.adresa.punaAdresa,
    //         mb: result.data.fizickoLiceDto.jmbg,
    //         tipStranke: TipStranke.FIZIKO_LICE,
    //         rokPlacanjaZaIzlazne:
    //           result.data.fizickoLiceDto.rokPlacanjaZaIzlazne,
    //         rokPlacanjaZaUlazne: result.data.fizickoLiceDto.rokPlacanjaZaUlazne,
    //       });
    //     }
    //   })
    // );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
